import { useBrowserInfo } from './use-browser-info'
import { BrowserType, checkBrowserType } from './use-check-browser-type'

/** Official web minimum majors (SPEC §1.3 / §8.3). Desktop shells are out of scope. */
export const MIN_BROWSER_MAJOR_VERSION: Partial<Record<BrowserType, number>> = {
  chrome: 100,
  edge: 100,
  opera: 100,
  firefox: 150,
  safari: 13,
}

export type MinimumBrowserVersionWarning = {
  name: string
  version: string
  minimum: number
}

const parseMajorVersion = (version: string): number | null => {
  const major = Number.parseInt(version.split('.')[0] ?? '', 10)
  return Number.isFinite(major) ? major : null
}

/**
 * Soft gate: returns warning payload when UA major is below the documented minimum.
 * Does not hard-block the app.
 */
export const getMinimumBrowserVersionWarning = (): MinimumBrowserVersionWarning | null => {
  const { userBrowser } = checkBrowserType()
  const minimum = MIN_BROWSER_MAJOR_VERSION[userBrowser.value]
  if (minimum == null) {
    return null
  }

  const { getBrowserInfo } = useBrowserInfo()
  const { name, version } = getBrowserInfo()
  const major = parseMajorVersion(version)
  if (major == null || major >= minimum) {
    return null
  }

  return { name, version, minimum }
}
